// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f92cd97b","732":"7a0e1f50","977":"8720b760"}[chunkId] + ".chunk.js";
};